import { agent } from './utils';
import { paint, fid, tti } from '../../performance';

function routerTrackEvent(history) {
    history.listen(location => {
        agent('trackEvent', { type: 'pageView', path: location.pathname });
    });
}

function reportPerformancePaintTimings() {
    return new Promise((resolve, reject) => {
        paint
            .getPerformancePaintTimings()
            .then(metrics => {
                // first-paint always comes back as entry 0
                // first-contentful-paint always comes back as 1
                const { 0: fp, 1: fcp } = metrics;
                resolve({
                    custom1: fp.startTime,
                    custom2: fcp.startTime
                });
            })
            .catch(error => {
                reject(error);
            });
    });
}

function reportFirstInputDelay() {
    return new Promise((resolve, reject) => {
        fid.tracking()
            .then(metric => {
                resolve({
                    custom3: metric.delay
                });
            })
            .catch(error => {
                reject(error);
            });
    });
}

function reportFirstConsistentlyInteractive(opts) {
    return new Promise((resolve, reject) => {
        tti.tracking(opts)
            .then(metric => {
                resolve({
                    custom4: metric
                });
            })
            .catch(error => {
                reject(error);
            });
    });
}

export { routerTrackEvent, reportPerformancePaintTimings, reportFirstInputDelay, reportFirstConsistentlyInteractive };
